<div class="payee-radio-group-wrapper">
  @for (option of options; track $index) {
    <payee-radio-button
      [labelPosition]="labelPosition"
      [checked]="option === value"
      (click)="selectOption(option)"
    >
      {{ displayWith(option) }}
    </payee-radio-button>
  }
  <ng-content select="payee-radio-button"></ng-content>
</div>
